/**
 * 商品管理路由
 * @Description: 商品管理模块路由及完整子路由
 *
 * @Author: JZT.Oscar
 * @Date: 2018-10-12 08:57:14
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2019-01-11 10:17:19
 */

export default [
    {
        path: "/goodsManage/limitSale",
        name: "限购管理",
        icon: "none",
        component: () => import("@/pages/goodsManage/limitSale/LimitSale"),
        meta: {
            comName: "LimitSale"
        }
    },
    {
        path: "/goodsManage/editLimitSale",
        name: "编辑限购策略",
        component: () =>
            import("@/pages/goodsManage/editLimitSale/EditLimitSale"),
        invisible: true,
        meta: {
            comName: "EditLimitSale"
        }
    },
    {
        path: "/goodsManage/addLimitSale",
        name: "添加限购策略",
        component: () =>
            import("@/pages/goodsManage/editLimitSale/EditLimitSale"),
        invisible: true,
        meta: {
            comName: "AddLimitSale"
        }
    },
    {
        path: "/goodsManage/viewLimitSale",
        name: "查看限购策略",
        component: () =>
            import("@/pages/goodsManage/editLimitSale/EditLimitSale"),
        invisible: true,
        meta: {
            comName: "ViewLimitSale"
        }
    },
    {
        path: "/goodsManage/busiCode",
        name: "经营简码",
        component: () => import("@/pages/goodsManage/busiCode"),
        icon: "none",
        meta: {
            comName: "busiCode",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/licenseManage",
        name: "证照管理",
        component: () =>
            import("@/pages/goodsManage/licenseManage/LicenseQuery"),
        icon: "none",
        meta: {
            comName: "LicenseQuery",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/sellapply",
        name: "售卖申请",
        component: () => import("@/pages/goodsManage/sellApply/Index"),
        icon: "none",
        meta: {
            comName: "sellApply",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/sellapply/sellapplyRequest",
        name: "证照资质上传",
        component: () =>
            import("@/pages/goodsManage/sellApply/sellapplyRequest"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "sellapplyRequest"
        }
    },
    {
        path: "/goodsManage/sellapply/myGoodslibModify",
        name: "修改证照资质",
        component: () =>
            import("@/pages/goodsManage/sellApply/myGoodslibModify"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "myGoodslibModify"
        }
    },
    {
        path: "/goodsManage/sellapply/GoodsAdd",
        name: "新增商品",
        component: () => import("@/pages/goodsManage/sellApply/GoodsAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "GoodsAdd"
        }
    },
    {
        path: "/goodsManage/licenseEdit",
        name: "编辑证照",
        component: () =>
            import("@/pages/goodsManage/licenseManage/LicenseEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "LicenseEdit"
        }
    },
    {
        path: "/goodsManage/licenseAdd",
        name: "新增证照",
        component: () => import("@/pages/goodsManage/licenseManage/licenseAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "licenseAdd"
        }
    },
    {
        path: "/goodsManage/goodsLib",
        name: "我的商品库",
        component: () => import("@/pages/goodsManage/goodsLib/Index"),
        icon: "none",
        meta: {
            comName: "myGoodsLib",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/goodsLib/salesApply",
        name: "批量售卖申请",
        component: () => import("@/pages/goodsManage/goodsLib/salesApply"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "salesApply",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/commodityAudit",
        name: "商品资料申请一级审核 ",
        component: () => import("@/pages/goodsManage/commodityAudit"),
        icon: "none",
        meta: {
            comName: "commodityAudit",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/commodityAuditSecond",
        name: "商品资料申请二级审核 ",
        component: () => import("@/pages/goodsManage/commodityAuditSecond"),
        icon: "none",
        meta: {
            comName: "commodityAuditSecond",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/applicationRecord",
        name: "申请记录查询",
        component: () => import("@/pages/goodsManage/applicationRecord"),
        icon: "none",
        meta: {
            comName: "applicationRecord",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/goodsMaintenance",
        name: "平台商品销售属性维护",
        component: () => import("@/pages/goodsManage/goodsMaintenance"),
        icon: "none",
        meta: {
            comName: "goodsMaintenance",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/agreedAreasQuery",
        name: "销售管控",
        component: () =>
            import("@/pages/goodsManage/agreedAreas/agreedAreasQuery"),
        icon: "none",
        meta: {
            comName: "agreedAreasQuery",
            needRefresh: true
        }
    },
    {
        path: "/goodsManage/agreedAreasAdd",
        name: "新建管控",
        component: () =>
            import("@/pages/goodsManage/agreedAreas/agreedAreasAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "agreedAreasAdd"
        }
    },
    {
        path: "/goodsManage/agreedAreasEdit",
        name: "编辑管控",
        component: () =>
            import("@/pages/goodsManage/agreedAreas/agreedAreasEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "agreedAreasEdit"
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/goods.js